import styled from 'styled-components'
import { StyledButtonBase } from 'components/Button/Button.styles'
import { Color } from 'root-constants'

export const StyledSubscriptionsBlockV2 = {
  Wrapper: styled.div`
    margin: 0 auto 28px;
    border-radius: 24px;
    background-size: cover;
  `,
  Title: styled.h2`
    margin-bottom: 40px;
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    color: ${Color.DARK};
  `,
  ButtonContainer: styled.div`
    margin: 16px 0;
  `,
  Button: styled.button`
    ${StyledButtonBase};
    margin: 40px auto;
    max-width: 328px;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
  `,
}
